// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__AAV0S","subheader":"ReorderModal_subheader__1eaLI","listWrap":"ReorderModal_listWrap__13IyA"};